import { render, staticRenderFns } from "./BaseAvatar.vue?vue&type=template&id=65f6d8b0&scoped=true&"
import script from "./BaseAvatar.vue?vue&type=script&lang=ts&"
export * from "./BaseAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAvatar.vue?vue&type=style&index=0&id=65f6d8b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6d8b0",
  null
  
)

export default component.exports